var map = {
	"./hezuo.png": 8138,
	"./hezuo_normal.png": 4942,
	"./map.png": 2313,
	"./map_normal.png": 9359,
	"./parking.png": 9555,
	"./parking_normal.png": 3237,
	"./phone.png": 3351,
	"./phone_normal.png": 1561,
	"./servicebge42837b.png": 7472,
	"./xuzhi.png": 3751,
	"./xuzhi_normal.png": 7673,
	"./youchuan.png": 7623,
	"./youchuan_normal.png": 6537,
	"./youlechang.png": 6148,
	"./youlechang_normal.png": 7516,
	"./youleyuan.png": 2956,
	"./youleyuan_normal.png": 4116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5689;